import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const PresentationContext = createContext(null);
const CHAVE = 'am_modo_exibicao';

// Estado só no navegador (sessionStorage) — nunca no backend. Isso não é uma regra de
// permissão nova (o operador já tem acesso legítimo a tudo), é uma rede de segurança contra
// vazar dado de outro hospital na tela enquanto ela apresenta pra um cliente. Por isso reseta
// a cada login/troca de usuário e ao fechar a aba — nunca "lembra" de sessão pra sessão.
function ler() {
  try {
    const bruto = sessionStorage.getItem(CHAVE);
    return bruto ? JSON.parse(bruto) : null;
  } catch {
    return null;
  }
}

export function PresentationProvider({ children }) {
  const { user, loading } = useAuth();
  const [estado, setEstado] = useState(ler);

  useEffect(() => {
    // Enquanto a sessão ainda está sendo verificada (GET /auth/me em andamento no boot do
    // app), `user` é null só porque ainda não resolveu — não é um logout de verdade. Sem essa
    // guarda, todo F5 durante uma apresentação apagava o modo apresentação silenciosamente.
    if (loading) return;
    if (!user) {
      sessionStorage.removeItem(CHAVE);
      setEstado(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id_usuario_portal, loading]);

  const salvar = (novo) => {
    sessionStorage.setItem(CHAVE, JSON.stringify(novo));
    setEstado(novo);
  };

  const escolherAdministracao = () => salvar({ modo: 'administracao' });
  const escolherApresentacao = (idsHospitais) => salvar({ modo: 'apresentacao', idsHospitais });

  // Zera pra "nenhum modo escolhido" (não pra "administracao") — assim o PrivateRoute
  // detecta `!modoEscolhido` e manda de volta pra tela de seleção de modo, em vez de só tirar
  // o filtro e deixar a pessoa continuar de onde estava (ver AppLayout.jsx, que também navega
  // explicitamente pra /modo-exibicao ao chamar isso).
  const sairApresentacao = () => {
    sessionStorage.removeItem(CHAVE);
    setEstado(null);
  };

  const apresentacaoAtiva = estado?.modo === 'apresentacao';

  const value = {
    modoEscolhido: estado !== null,
    apresentacaoAtiva,
    hospitaisPermitidos: apresentacaoAtiva ? estado.idsHospitais : null, // null = sem restrição
    escolherAdministracao,
    escolherApresentacao,
    sairApresentacao,
  };

  return <PresentationContext.Provider value={value}>{children}</PresentationContext.Provider>;
}

export const usePresentation = () => useContext(PresentationContext);
